import React from "react";
import {ColumnGroup} from "primereact/columngroup";
import {Row} from "primereact/row";
import {Column} from "primereact/column";
import BilateralGuaranteeInAccountView from "./BilateralGuaranteeInAccountView";
import {amount, amountCalculate, decimalFormat, numberWithCommaEmptyValue, price} from "../../utils/formatters/Numbers";
import NumberFormat from "react-number-format";
import {getSuggestedInAccount, getZeroOrNewTitles, withoutComma} from "../../utils/calculate/Amount";
import PropTypes from "prop-types";
import {BilateralCatalogService} from "../../service/bilateral/catalog/BilateralCatalogService";


export default class BilateralGuaranteeInAccountContainer extends React.Component {
    constructor(props) {
        super(props)

        this.bilateralCatalogService = new BilateralCatalogService();

        this.getGuaranteeToAssign = this.getGuaranteeToAssign.bind(this);
        this.styleInstrumentAmountTemplate = this.styleInstrumentAmountTemplate.bind(this);
        this.styleInstrumentPriceTemplate = this.styleInstrumentPriceTemplate.bind(this);
        this.styleInstrumentNumberTemplate = this.styleInstrumentNumberTemplate.bind(this);
        this.styleInstrumentCapacityTemplate = this.styleInstrumentCapacityTemplate.bind(this);

        this.calculateAmounts = this.calculateAmounts.bind(this);
        this.setTotalsColor = this.setTotalsColor.bind(this);
        this.numberEditor = this.numberEditor.bind(this);
        this.onEditorValueChange = this.onEditorValueChange.bind(this);
        this.updateCollateralMapToAssign = this.updateCollateralMapToAssign.bind(this);
        this.show = this.show.bind(this);

        this.state = {
            subtitle: props.subtitle ?? 'Garantías en cuenta',
            loanId: props.selectedLoan.id,
            loanAmount: props.selectedLoan.amount,
            guaranteeList: [],
            collateralToAssignMap: new Map(),
            guaranteedAmountTotal: 0,
            marketAmountTotal: 0,
            guaranteedAmountInLoan: 0,
            marketAmountInLoan: 0,
            cssStyle:
                props.isHidden === undefined || !props.isHidden ? 'p-toggleable-content-enter-done'
                    : 'p-toggleable-content-collapsed',
            totalColor: 'red',
        };
    }

    show() {
        this.setState({
            cssStyle: 'p-toggleable-content-enter-done',
        })
    }

    componentDidMount() {
        let loanId = this.props.selectedLoan?.id;
        this.getGuaranteeToAssign(loanId);

    }

    componentDidUpdate(prevProps) {
        const prevId = prevProps.selectedLoan?.id;
        const currentId = this.props.selectedLoan?.id;

        if (currentId !== prevId) {
            this.setState({
                loanId: currentId,
                loanAmount: this.props.selectedLoan?.amount
            });
            if (currentId) {
                this.getGuaranteeToAssign(currentId);
            }
        }
    }

    calculateSuggested(guaranteedAmountInLoan) {
        this.setState((prevState) => {
            let realGuaranteedAmountTotal = guaranteedAmountInLoan === undefined
                ? prevState.guaranteedAmountTotal : guaranteedAmountInLoan;
            let guaranteeList = [...prevState.guaranteeList];
            for (const item of guaranteeList) {
                item['suggested'] = this.getSuggestedTitles(
                    prevState.loanAmount, realGuaranteedAmountTotal, item['discountedPrice']);
            }
            return {
                guaranteeList: guaranteeList,
            };
        });
    }

    calculateAmounts(collateralList, guaranteedAmountInLoan, marketAmountInLoan) {
        let guaranteeAmountTotal = 0;
        let marketAmountTotal = 0;

        this.setState((prevState) => {
            let realGuaranteedAmountInLoan = guaranteedAmountInLoan === undefined
                ? prevState.guaranteedAmountInLoan : guaranteedAmountInLoan;
            let realMarketAmountInLoan = marketAmountInLoan === undefined
                ? prevState.marketAmountInLoan : marketAmountInLoan;
            for (const item of collateralList) {
                item['guaranteedAmount'] = this.getGuaranteedAmount(item);
                item['marketAmount'] = this.getMarketAmount(item);
                guaranteeAmountTotal += item['guaranteedAmount'];
                marketAmountTotal += item['marketAmount'];
            }
            let realGuaranteedAmountTotal = guaranteeAmountTotal + realGuaranteedAmountInLoan;
            this.setTotalsColor(realGuaranteedAmountTotal);
            return {
                guaranteeList: collateralList,
                guaranteedAmountTotal: realGuaranteedAmountTotal,
                marketAmountTotal: marketAmountTotal + realMarketAmountInLoan,
            };
        });
    }

    setTotalsColor(guaranteedAmountTotal) {
        this.setState((prevState) => {
            const loanAmount = prevState.loanAmount;
            let totalColorAux = loanAmount <= amountCalculate(guaranteedAmountTotal) ? 'green' : 'red';
            return {totalColor: totalColorAux,};
        });
    }

    getGuaranteedAmount(collateral) {
        let newTitles = getZeroOrNewTitles(collateral['newTitles']);
        return collateral['discountedPrice'] * newTitles;
    }

    getMarketAmount(collateral) {
        let newTitles = getZeroOrNewTitles(collateral['newTitles']);
        return collateral['price24Hours'] * newTitles;
    }

    getSuggestedTitles(loanAmount, realGuaranteedAmountTotal, price) {
        let suggestedTitles = getSuggestedInAccount(loanAmount, realGuaranteedAmountTotal, price);
        return Math.max(suggestedTitles, 0);
    }

    getGuaranteeToAssign(loanId) {
        let validLoanId = loanId || this.state.loanId;

        if (!validLoanId) {
            return;
        }

        this.bilateralCatalogService.getCollateralToAssign(loanId)
            .then(res => {
                if (this.validResponse(res)) {
                    this.setState({
                        guaranteeList: res.data,
                        guaranteedAmountInLoan: this.props.guaranteedAmountInLoan ?? 0,
                        marketAmountInLoan: this.props.marketAmountInLoan ?? 0
                    });

                    this.calculateAmounts(
                        res.data, this.props.guaranteedAmountInLoan, this.props.marketAmountInLoan);
                    this.calculateSuggested(this.props.guaranteedAmountInLoan);
                }
                this.props.loading(false);
            });
    }

    validResponse(res) {
        if (res.status !== 200) {
            this.growl.show({
                severity: 'error', summary: 'Error.',
                detail: res.message + ' ' + res.debugMessage
            });
            return false;
        }
        return true;
    }

    onEditorValueChange(props, value) {
        let guarantee = [...props.value];
        let valueNumber = withoutComma(value);
        let collateralId = props.rowData.id;

        guarantee[props.rowIndex][props.field] = valueNumber === 0 ? '' : valueNumber;

        this.setState({guaranteeList: guarantee});
        this.calculateAmounts(guarantee);
        this.updateCollateralMapToAssign(collateralId, valueNumber);
    }

    updateCollateralMapToAssign(collateralId, newTitles) {
        this.setState((prevState) => {
            let collateralMap = prevState.collateralToAssignMap;
            if (newTitles === 0) {
                collateralMap.delete(collateralId)
            } else {
                collateralMap.set(collateralId, newTitles)
            }
            return {collateralToAssignMap: collateralMap};
        });
    }

    numberEditor(props, field) {
        return <NumberFormat
            className={"p-inputtext p-component"}
            value={props.rowData.newTitles}
            thousandSeparator={true}
            allowNegative={false}
            onChange={(e) => this.onEditorValueChange(props, e.target.value)}
            onBlur={(e) => this.calculateSuggested()}
        />;
    }

    styleInstrumentAmountTemplate(rowData, column) {
        return amount(rowData[column.field], "right");
    }

    styleInstrumentPriceTemplate(rowData, column) {
        return price(rowData[column.field], "right");
    }

    styleInstrumentNumberTemplate(rowData, column) {
        return numberWithCommaEmptyValue(rowData[column.field], "right")
    }

    styleInstrumentCapacityTemplate(rowData, column) {
        return decimalFormat(rowData[column.field], "right", 4);
    }

    render() {
        let footerColumnGroup =
            <ColumnGroup>
                <Row>
                    <Column footer="Totales:" colSpan={6} style={{textAlign: 'right'}}/>
                    <Column footer={amount(this.state.guaranteedAmountTotal, 'right')}
                            style={{color: this.state.totalColor}}/>
                    <Column footer={amount(this.state.marketAmountTotal, 'right')}
                            style={{color: this.state.totalColor}}/>
                </Row>
            </ColumnGroup>;


        return <BilateralGuaranteeInAccountView
            styleInstrumentAmountTemplate={this.styleInstrumentAmountTemplate}
            styleInstrumentPriceTemplate={this.styleInstrumentPriceTemplate}
            styleInstrumentNumberTemplate={this.styleInstrumentNumberTemplate}
            styleInstrumentCapacityTemplate={this.styleInstrumentCapacityTemplate}
            numberEditor={this.numberEditor}
            guaranteeList={this.state.guaranteeList}
            footerColumnGroup={footerColumnGroup}
            cssStyle={this.state.cssStyle}
            subtitle={this.state.subtitle}
        />
    }
};

BilateralGuaranteeInAccountContainer.propTypes = {
    selectedLoan: PropTypes.object.isRequired,
    loading: PropTypes.func.isRequired,
    isHidden: PropTypes.bool,
    guaranteedAmountInLoan: PropTypes.number,
    marketAmountInLoan: PropTypes.number,
};